// extracted by mini-css-extract-plugin
export default {"Emoji":"bbc_a bhe_i bhe_q bhe_j"};